import { divisions } from "../data";

export default function EditorialMarquee() {
  const items = ["PRODUCTS FOR DAILY BUSINESS", "CLEAR TECHNICAL HELP", "STEADY PRODUCTION", "NETS, FILMS AND PACKAGING", "MADE IN VARANASI", "OPTIONS FOR YOUR LINE"];
  return <div className="marquee-window" data-testid="editorial-marquee" aria-label="SGN manufacturing facts"><div className="marquee-track">{[...items, ...items].map((item, index) => <span className="marquee-item" key={`${item}-${index}`}>{item}<b>＋</b></span>)}</div></div>;
}

export function DivisionCode({ id }: { id: string }) {
  return <span className="division-code">{divisions.find((division) => division.id === id)?.code}</span>;
}
